import gql from 'graphql-tag'

export const CHECK_AUTH = gql`
    query CheckAuth {
        isAuthenticated @client
    }
`

export const TOGGLE_AUTH = gql`
    mutation ToggleAuth ($isAuthenticated: Boolean!) {
        toggleAuth(isAuthenticated: $isAuthenticated) @client
    }
`

export const GET_API_KEYS = gql`
    query GetApiKeys {
        apiKeys {
            name
            keyMask
            scopes {
                scope
                actions
            }
        }
    }
`

export const ADD_API_KEY = gql`
    mutation AddApiKey($data: AddApiKeyInput!) {
        addApiKey(data: $data) {
            key
        }
    }
`


// WEBPACK FOOTER //
// ./src/operations/Auth/index.js